(ns ycweb.util.directprint
  (:require
   #?@(:clj
       [[clojure.core.async :as a]]
       :cljs
       [[cljs.core.async :as a]])
   [rum.core :as rum]
   [util.string :as str]
   [util.transform :as trf]
   [ycweb.components.common :as cmn]
   [ycweb.components.grid :as grid]
   [ycweb.components.toaster :as toaster]
   [ycweb.components.headings :as headings]
   [ycweb.components.transitions :as t]
   [ycweb.util.comms :as comms]
   [ycweb.util.core :as uc]))

(def test-printers
  [{:job-count 0,
    :ip-address "192.168.1.62",
    :state "idle",
    :printer-attributes
    {:printer-uri-supported "ipp://192.168.1.62/ipp/print",
     :printer-location "",
     :printer-make-and-model "TEST Brother HL-L2360D series",
     :printer-state-reasons "none",
     :printer-icons ""},
    :job-summary [],
    :marker-info
    [{:name "BK", :colour "Black", :level 50, :level-perc 50, :colour-code "#000000", :level-low 10, :level-high 100, :marker-type "toner"}]}
   {:job-count 0, :ip-address "192.168.42.239", :state "idle",
    :printer-attributes
    {:printer-icons "",
     :printer-state-reasons ["offline-report" "other-error" "wifi-not-configured-report" "cups-ipp-conformance-failure-report" "cups-ipp-missing-job-history"],
     :printer-uri-supported "ipp://192.168.42.239:631/printers/HP_PageWide_Pro_477dw_MFP",
     :printer-location "",
     :printer-make-and-model "TEST HP PageWide Pro 477 MFP"},
    :job-summary [],
    :marker-info
    [{:name "yellow", :colour "Yellow", :level 40, :level-perc 40, :colour-code "#ffff00", :level-low 20, :level-high 100, :marker-type "ink"}
     {:name "magenta", :colour "Magenta", :level 40, :level-perc 40, :colour-code "#ff00ff", :level-low 20, :level-high 100, :marker-type "ink"}
     {:name "cyan", :colour "Cyan", :level 30, :level-perc 30, :colour-code "#00ffff", :level-low 20, :level-high 100, :marker-type "ink"}
     {:name "black", :colour "Black", :level 5, :level-perc 5, :colour-code "#000000", :level-low 20, :level-high 100, :marker-type "ink"}]}
   {:job-count 0, :ip-address "192.168.1.80", :state "idle",
    :printer-attributes
    {:printer-uri-supported ["ipp://192.168.1.80:631/ipp/print" "ipps://192.168.1.80:443/ipp/print"],
     :printer-location "OH Marketing",
     :printer-make-and-model "TEST Canon iR-ADV C3725",
     :printer-state-reasons "toner-low-warning",
     :printer-icons "",
     :printer-firmware-string-version 25.14},
    :job-summary [],
    :marker-info
    [{:name "Canon C-EXV 49 Black Toner", :colour "Black", :level 64, :level-perc 64, :colour-code "#000000", :level-low 7, :level-high 100, :marker-type "toner"}
     {:name "Canon C-EXV 49 Cyan Toner", :colour "Cyan", :level 94, :level-perc 94, :colour-code "#00FFFF", :level-low 7, :level-high 100, :marker-type "toner"}
     {:name "Canon C-EXV 49 Magenta To", :colour "Magenta", :level 93, :level-perc 93, :colour-code "#FF00FF", :level-low 7, :level-high 100, :marker-type "toner"}
     {:name "Canon C-EXV 49 Yellow Ton", :colour "Yellow", :level 86, :level-perc 86, :colour-code "#FFFF00", :level-low 7, :level-high 100, :marker-type "toner"}]}])

(defn log [msg]
  (comms/send :pos/log msg))

(declare list-printer-attributes-async-available?)
(declare list-printer-attributes-async)

(defn list-printer-attributes [printer-uri requested-attributes-map]
  #?(:cljs
     (when (uc/capability-exists? :direct-print)
       (let [printer-jobs (.listPrinterAttributes js/PrintingInterface printer-uri "")]
         printer-jobs))))

(defn ipp-direct-print [app-atom {:keys [connection/uri printer/job config]}]
  #?(:cljs
     (let [printer-job (uc/json-string job)]
       (.ippPrint js/PrintingInterface uri printer-job))))

(defn ipp-print-async-available?
  "Check if the async IPP print method is available on this device."
  []
  #?(:cljs
     (and
       (uc/capability-exists? :direct-print)
       (exists? js/PrintingInterface)
       (exists? (.-ippPrintAsync js/PrintingInterface)))
     :clj false))

(defn ipp-direct-print-async
  "Async version of IPP print that doesn't block the UI thread.
   Registers a callback, calls the async method, and handles the response."
  [app-atom {:keys [connection/uri printer/job]} on-complete]
  #?(:cljs
     (let [callback-id (str (random-uuid))
           printer-job-json (uc/json-string job)
           completed? (atom false)]
       ;; Register the callback handler on window
       (aset js/window "ippPrintCallback"
         (fn [id result-str]
           (when (and (= id callback-id) (not @completed?))
             (reset! completed? true)
             (try
               (let [result (uc/json-parse result-str)]
                 (on-complete result))
               (catch js/Error e
                 (log {:error "Failed to parse ippPrintAsync response"
                       :message (.-message e)
                       :result-str result-str})
                 (on-complete {:success false
                               :message (str "Parse error: " (.-message e))
                               :job-id 0}))))))
       ;; Set a timeout in case callback never fires (30 seconds)
       (js/setTimeout
         (fn []
           (when (not @completed?)
             (reset! completed? true)
             (on-complete {:success false
                           :message "Print operation timed out"
                           :job-id 0
                           :timeout true})))
         30000)
       ;; Fire the async print
       (.ippPrintAsync js/PrintingInterface uri printer-job-json callback-id))
     :clj nil))

(defn socket-print-async-available?
  "Check if the async socket print method is available on this device."
  []
  #?(:cljs
     (and
       (uc/capability-exists? :direct-print)
       (exists? js/PrintingInterface)
       (exists? (.-printAsync js/PrintingInterface)))
     :clj false))

(defn socket-direct-print-async
  "Async version of socket print that doesn't block the UI thread.
   Registers a callback, calls the async method, and handles the response."
  [app-atom {:keys [connection/ip connection/port connection/channel printer/job config]} on-complete]
  #?(:cljs
     (let [callback-id (str (random-uuid))
           completed? (atom false)]
       ;; Register the callback handler on window
       (aset js/window "socketPrintCallback"
         (fn [id result-str]
           (when (and (= id callback-id) (not @completed?))
             (reset! completed? true)
             (try
               (let [result (uc/json-parse result-str)]
                 (on-complete result))
               (catch js/Error e
                 (log {:error "Failed to parse printAsync response"
                       :message (.-message e)
                       :result-str result-str})
                 (on-complete {:success false
                               :message (str "Parse error: " (.-message e))}))))))
       ;; Set a timeout in case callback never fires (20 seconds - 5s connect + 10s write + buffer)
       (js/setTimeout
         (fn []
           (when (not @completed?)
             (reset! completed? true)
             (on-complete {:success false
                           :message "Print operation timed out"
                           :timeout true})))
         20000)
       ;; Fire the async print
       (.printAsync js/PrintingInterface
         ip
         (or port 9100)
         (or channel "socket")
         (:content job)
         callback-id))
     :clj nil))

(defn simple-direct-print [app-atom {:keys [connection/ip connection/port connection/channel printer/job config] :as printer-config}]
  #?(:cljs
     (let [handle-result
           (fn [{:keys [success message]}]
             (cond
               success
               (do
                 (when (toaster/is-open? app-atom :pos/printing)
                   (toaster/close-overlay app-atom :pos/printing))
                 (when (uc/presence (:next-screen config))
                   (t/transition-next app-atom (:next-screen config))))

               :else
               (do
                 (when (toaster/is-open? app-atom :pos/printing)
                   (toaster/close-overlay app-atom :pos/printing))
                 (let [user-message
                       (cond
                         ;; Connection refused or failed to connect
                         (and message (str/includes? message "failed to connect"))
                         "Printer not available - please check if it's turned on"

                         ;; Timeout errors
                         (and message (str/includes? message "timed out"))
                         "Connection timed out - printer may be offline"

                         ;; Connection refused
                         (and message (str/includes? message "refused"))
                         "Printer not available - please check if it's turned on"

                         ;; Host unreachable
                         (and message (str/includes? message "unreachable"))
                         "Cannot reach printer - check network connection"

                         ;; Default: show original error
                         :else
                         (str "Failed to print: " (or message "Unknown error")))]
                   (toaster/open-toast app-atom :error user-message {:closetime 5000}))
                 (log {:error "Socket print failed"
                       :message message
                       :ip ip
                       :port port}))))]

       ;; Use async if available, otherwise fall back to sync (fire-and-forget)
       (if (socket-print-async-available?)
         (socket-direct-print-async app-atom printer-config handle-result)
         ;; Fallback: synchronous call (no feedback, assumes success)
         (do
           (.print js/PrintingInterface ip (or port 9100) (or channel "socket") (:content job))
           (when (toaster/is-open? app-atom :pos/printing)
             (toaster/close-overlay app-atom :pos/printing))
           (when (uc/presence (:next-screen config))
             (t/transition-next app-atom (:next-screen config))))))))

(defn- handle-ipp-print-result
  "Handles the result of an IPP print operation (used by both sync and async paths)."
  [app-atom printer-job connection-uri job-response]
  #?(:cljs
     (let [printer-atom (rum/cursor-in app-atom [:printers (:device/name printer-job)])
           current-jobs (cmn/curact printer-atom :current-jobs)
           device-info (cmn/curact app-atom :device)
           capabilities (uc/device-capabilities)
           {:keys [success job-id]} job-response]
       (cond
         (and (not success) (zero? (trf/tonumber job-id)))
         (let [attributes (list-printer-attributes connection-uri "*")
               error-msg (:message job-response)
               user-message
               (cond
                 (and error-msg (str/includes? error-msg "connect"))
                 "Printer not available - please check if it's turned on"

                 (and error-msg (str/includes? error-msg "timed out"))
                 "Connection timed out - printer may be offline"

                 :else
                 "Failed to print. Please try again")]
           (toaster/open-toast app-atom :error user-message {:closetime 8000})
           (log
             {:connection-uri connection-uri
              :job-response job-response
              :device-info device-info
              :capabilities capabilities
              :printer-job (update printer-job :printer/job dissoc :content)
              :printer-attributes attributes}))

         success
         (do
           (when (toaster/is-open? app-atom :pos/printing)
             (toaster/update-overlay-message app-atom :pos/printing {:text "Sent to printer"}))
           (swap! printer-atom update :current-jobs
             (fn [printer-jobs]
               (cond
                 printer-jobs (conj printer-jobs job-id)
                 :else #{job-id})))
           (when (empty? current-jobs)
             (grid/dispatch-action app-atom :store-admin/poll-printer-job
               (assoc printer-job
                 :job/id job-id
                 :connection/uri connection-uri))))))))

(defn- ipp-connection-uri
  "Construct the IPP connection URI from printer-job fields."
  [{:keys [connection/ip connection/port connection/resource-path connection/uri]}]
  (or uri
    (str "ipp://" ip (when port (str ":" port))
      (when (and resource-path (not (str/starts-with? resource-path "/"))) "/")
      resource-path)))

(defn- do-ipp-print
  "Execute the IPP print job. Handles toaster updates and dispatches
   to async or sync print path."
  [app-atom {:keys [documents] :as printer-job} connection-uri]
  #?(:cljs
     (let [{:keys [current-number total-number]} documents
           printer-config (assoc printer-job :connection/uri connection-uri)]
       (when (toaster/is-open? app-atom :pos/printing)
         (toaster/update-overlay-message app-atom :pos/printing
           {:text
            (if (= current-number total-number)
              (str "Sent " total-number " jobs to printer")
              (str "Sending job to printer: " current-number " of " total-number))}))

       ;; Use async if available (doesn't block UI), otherwise fall back to sync
       (if (ipp-print-async-available?)
         (ipp-direct-print-async app-atom printer-config
           (fn [job-response]
             (handle-ipp-print-result app-atom printer-job connection-uri job-response)))
         ;; Fallback: synchronous call (blocks UI on older APKs)
         (let [job-response (uc/json-parse
                              (ipp-direct-print app-atom printer-config))]
           (handle-ipp-print-result app-atom printer-job connection-uri job-response))))))

(defn- warm-up-and-print
  "Wake a sleeping IPP printer by sending a Get-Printer-Attributes request
   before the actual print job. Only warms up on the first document of a batch.
   Falls back to printing directly if async attributes is not available."
  [app-atom {:keys [documents] :as printer-job}]
  #?(:cljs
     (let [connection-uri (ipp-connection-uri printer-job)
           {:keys [current-number]} documents
           first-document? (or (nil? current-number) (= current-number 1))]
       (cond
         ;; Only warm up on the first document; subsequent docs go straight to print
         (and first-document? (list-printer-attributes-async-available?))
         (do
           (when (toaster/is-open? app-atom :pos/printing)
             (toaster/update-overlay-message app-atom :pos/printing
               {:text "Preparing printer..."}))
           (log {:event "ipp-warm-up-start" :uri connection-uri})
           (list-printer-attributes-async
             connection-uri
             "printer-state"
             (fn [result]
               (log {:event "ipp-warm-up-complete"
                     :success (:success result)
                     :uri connection-uri})
               ;; Proceed with print regardless of warm-up result
               (do-ipp-print app-atom printer-job connection-uri))))

         :else
         (do-ipp-print app-atom printer-job connection-uri)))))

(defn- legacy-ipp-print
  "IPP print path without warm-up. Used when the
   pos/device-printer feature flag is off."
  [app-atom {:keys [connection/ip connection/port connection/resource-path connection/uri documents] :as printer-job}]
  #?(:cljs
     (let [{:keys [current-number total-number]} documents
           connection-uri
           (or uri
             (str "ipp://" ip (when port (str ":" port))
               (when (and resource-path (not (str/starts-with? resource-path "/"))) "/")
               resource-path))
           printer-config (assoc printer-job :connection/uri connection-uri)]
       (toaster/close-subtle-progress app-atom)
       (when (toaster/is-open? app-atom :pos/printing)
         (toaster/update-overlay-message app-atom :pos/printing
           {:text
            (if (= current-number total-number)
              (str "Sent " total-number " jobs to printer")
              (str "Sending job to printer: " current-number " of " total-number))}))

       ;; Use async if available (doesn't block UI), otherwise fall back to sync
       (if (ipp-print-async-available?)
         (ipp-direct-print-async app-atom printer-config
           (fn [job-response]
             (handle-ipp-print-result app-atom printer-job connection-uri job-response)))
         ;; Fallback: synchronous call (blocks UI on older APKs)
         (let [job-response (uc/json-parse
                              (ipp-direct-print app-atom printer-config))]
           (handle-ipp-print-result app-atom printer-job connection-uri job-response))))))

(defn direct-print
  [app-atom {:keys [connection/channel] :as printer-job}]
  #?(:cljs
     (cond
       (= channel "ipp")
       (if (get-in @app-atom [:config :device-printer-enabled])
         (do
           (toaster/close-subtle-progress app-atom)
           (warm-up-and-print app-atom printer-job))
         (legacy-ipp-print app-atom printer-job))

       :else
       (do
         (when (toaster/is-open? app-atom :pos/printing)
           (toaster/update-overlay-message app-atom :pos/printing {:text "Printing"}))
         (simple-direct-print app-atom printer-job)))))

(defn restart-job [printer-job]
  #?(:cljs
     (let [printer-job (uc/json-string printer-job)]
       (.restartPrintJob js/PrintingInterface printer-job))))

(defn release-job [printer-job]
  #?(:cljs
     (let [printer-job (uc/json-string printer-job)]
       (.releasePrintJob js/PrintingInterface printer-job))))

(defn cancel-job [printer-job]
  #?(:cljs
     (let [printer-job (uc/json-string printer-job)]
       (.cancelPrintJob js/PrintingInterface printer-job))))

(defn ping-device [ip-address]
  #?(:cljs
     (when
       (and
         (uc/capability-exists? :direct-print)
         (exists? (.-isDeviceReachable js/PrintingInterface)))
       (.isDeviceReachable js/PrintingInterface ip-address))))

(defn ping-to-print [app-atom {:keys [connection/ip] :as printer-job}]
  (cond
    (toaster/is-open? app-atom :pos/printing)
    (toaster/update-overlay-message app-atom :pos/printing
      {:text "Checking network for device"})

    :else
    (toaster/open-toast app-atom :processing "Checking network for device" {}))

  (let [ping-channel (a/chan)]
    (a/go
      (a/>! ping-channel
        (ping-device ip)))
    (a/go-loop [retry-count 1]
      (let [reachable? (a/<! ping-channel)]
        (cond
          (and (not (nil? reachable?)) reachable?)
          (do
            (toaster/close-toast app-atom)
            (direct-print app-atom printer-job))

          (or
            (and (not (nil? reachable?)) (not reachable?))
            (>= retry-count 10))
          (toaster/open-toast app-atom :error "Failed to communicate with the device" {:closetime 3000})

          :else
          (do
            (a/<! (a/timeout 500))
            (recur (inc retry-count))))))))

(defn device-print-structured
  "Handle printing to Sunmi device printer with structured print jobs.
   Supports both legacy ESC/POS strings and new structured jobs (vector of segments)."
  [app-atom printer-config]
  #?(:cljs
     (try
       (toaster/open-overlay app-atom :pos/printing
         {:title "Printing..."
          :sub-text "Sending to device printer"})

       (let [job (get-in printer-config [:printer/job :content])]
         (cond
           ;; Structured job (vector of typed segments)
           (vector? job)
           (do
             (.printStructuredJob js/PrintingInterface (uc/json-string job))
             (js/setTimeout
               #(do
                  (toaster/close-overlay app-atom :pos/printing)
                  (when-let [next-screen (cmn/curact app-atom [:printers :transition-to])]
                    (t/transition-next app-atom next-screen)))
               2000))

           ;; Legacy: ESC/POS string (fallback)
           (string? job)
           (do
             (.device_print js/PrintingInterface job)
             (js/setTimeout
               #(do
                  (toaster/close-overlay app-atom :pos/printing)
                  (when-let [next-screen (cmn/curact app-atom [:printers :transition-to])]
                    (t/transition-next app-atom next-screen)))
               1500))

           ;; Unsupported template for device printer
           :else
           (throw (js/Error. "This print template is not supported on the device printer. Please scan a Bixolon printer."))))

       (catch js/Error e
         (toaster/close-overlay app-atom :pos/printing)
         (log {:error "Device print failed" :message (.-message e)})
         (grid/open-modal app-atom :device-print/error-modal
           {:error-message (.-message e)
            :original-config printer-config})))))

(defmethod comms/receive :print/direct [app-atom printer-config]
  #?(:cljs
     ;;TODO Server side direct print for Dev
     (let [channel (:connection/channel printer-config)
           device-print? (= channel "device-print")

           simple-dp-capability?
           (and
             (uc/capability-exists? :direct-print)
             (exists? (.-print js/PrintingInterface)))

           ipp-dp-capability?
           (and
             (uc/capability-exists? :direct-print)
             (exists? (.-ippPrint js/PrintingInterface)))

           device-printer-capability? (uc/has-device-printer?)

           device-info (cmn/curact app-atom :device)
           capabilities (uc/device-capabilities)

           ping-fn?
           (and
             (uc/capability-exists? :direct-print)
             (uc/presence (:version-code device-info))
             (>= (trf/tonumber (:version-code device-info)) 118))

           ping-or-print-fn
           (fn []
             (if ping-fn?
               (ping-to-print app-atom printer-config)
               (direct-print app-atom printer-config)))]

       (cond
         ;; NEW: Handle device printing (Sunmi) with structured jobs
         (and device-print? device-printer-capability?)
         (device-print-structured app-atom printer-config)

         (and
           (not simple-dp-capability?)
           (not ipp-dp-capability?))
         (grid/open-modal app-atom :direct-print/upgrade-alert
           {:severity :error
            :simple-dp-capability? simple-dp-capability?
            :ipp-dp-capability? ipp-dp-capability?
            :device-info device-info
            :capabilities capabilities})

         (and
           simple-dp-capability?
           (not ipp-dp-capability?))
         (do
           (when (not= channel "ipp")
             (ping-or-print-fn))
           (grid/open-modal app-atom :direct-print/upgrade-alert
             {:severity :warning
              :simple-dp-capability? simple-dp-capability?
              :ipp-dp-capability? ipp-dp-capability?
              :device-info device-info
              :capabilities capabilities}))

         (and simple-dp-capability? ipp-dp-capability?)
         (ping-or-print-fn)

         :else
         (grid/open-modal app-atom :direct-print/upgrade-alert
           {:severity :unknown
            :simple-dp-capability? simple-dp-capability?
            :ipp-dp-capability? ipp-dp-capability?
            :device-info device-info
            :capabilities capabilities})))))

(defn list-printers [app-atom requested-attributes-map]
  #?(:cljs
     (cond
       (and
         (uc/capability-exists? :direct-print)
         (exists? (.-listPrinters js/PrintingInterface)))
       (.listPrinters js/PrintingInterface requested-attributes-map)

       (cmn/has-permission? app-atom "SiteAdmin:Teams:Development")
       test-printers

       :else
       [])))

(defn list-printers-async-available?
  "Check if the async list printers method is available on this device."
  []
  #?(:cljs
     (and
       (uc/capability-exists? :direct-print)
       (exists? js/PrintingInterface)
       (exists? (.-listPrintersAsync js/PrintingInterface)))
     :clj false))

(defn list-printers-async
  "Async version of list-printers that doesn't block the UI thread.
   Registers a callback, calls the async method, and handles the response."
  [app-atom requested-attributes on-complete]
  #?(:cljs
     (let [callback-id (str (random-uuid))
           completed? (atom false)]
       ;; Register the callback handler on window
       (aset js/window "listPrintersCallback"
         (fn [id result-str]
           (when (and (= id callback-id) (not @completed?))
             (reset! completed? true)
             (try
               (let [result (uc/json-parse result-str)]
                 (on-complete {:success true :printers result}))
               (catch js/Error e
                 (log {:error "Failed to parse listPrintersAsync response"
                       :message (.-message e)
                       :result-str result-str})
                 (on-complete {:success false
                               :message (str "Parse error: " (.-message e))
                               :printers []}))))))
       ;; Set a timeout in case callback never fires (45 seconds for network discovery)
       (js/setTimeout
         (fn []
           (when (not @completed?)
             (reset! completed? true)
             (on-complete {:success false
                           :message "Printer discovery timed out"
                           :printers []
                           :timeout true})))
         45000)
       ;; Fire the async discovery
       (.listPrintersAsync js/PrintingInterface (or requested-attributes "") callback-id))
     :clj nil))

(defn list-printer-jobs [printer-uri]
  #?(:cljs
     (when (uc/capability-exists? :direct-print)
       (let [printer-jobs (.listPrinterJobs js/PrintingInterface printer-uri)]
         printer-jobs))))

;;===============================================================
;;                    ASYNC ATTRIBUTE METHODS
;;===============================================================

(defn list-printer-attributes-async-available?
  "Check if the async printer attributes method is available on this device."
  []
  #?(:cljs
     (and
       (uc/capability-exists? :direct-print)
       (exists? js/PrintingInterface)
       (exists? (.-listPrinterAttributesAsync js/PrintingInterface)))
     :clj false))

(defn list-printer-attributes-async
  "Async version of list-printer-attributes that doesn't block the UI thread.
   Registers a callback, calls the async method, and handles the response."
  [printer-uri requested-attributes on-complete]
  #?(:cljs
     (let [callback-id (str (random-uuid))
           completed? (atom false)]
       ;; Register the callback handler on window
       (aset js/window "printerAttributesCallback"
         (fn [id result-str]
           (when (and (= id callback-id) (not @completed?))
             (reset! completed? true)
             (try
               (let [result (uc/json-parse result-str)]
                 (on-complete {:success true :attributes result}))
               (catch js/Error e
                 (log {:error "Failed to parse listPrinterAttributesAsync response"
                       :message (.-message e)
                       :result-str result-str})
                 (on-complete {:success false
                               :message (str "Parse error: " (.-message e))
                               :attributes nil}))))))
       ;; Set a timeout in case callback never fires (15 seconds)
       (js/setTimeout
         (fn []
           (when (not @completed?)
             (reset! completed? true)
             (on-complete {:success false
                           :message "Attribute fetch timed out"
                           :attributes nil
                           :timeout true})))
         15000)
       ;; Fire the async call
       (.listPrinterAttributesAsync js/PrintingInterface
         printer-uri (or requested-attributes "") callback-id))
     :clj nil))

(defn list-marker-details-async-available?
  "Check if the async marker details method is available on this device."
  []
  #?(:cljs
     (and
       (uc/capability-exists? :direct-print)
       (exists? js/PrintingInterface)
       (exists? (.-listMarkerDetailsAsync js/PrintingInterface)))
     :clj false))

(defn list-marker-details-async
  "Async version of list-printer-markers that doesn't block the UI thread.
   Registers a callback, calls the async method, and handles the response."
  [printer-uri on-complete]
  #?(:cljs
     (let [callback-id (str (random-uuid))
           completed? (atom false)]
       ;; Register the callback handler on window
       (aset js/window "markerDetailsCallback"
         (fn [id result-str]
           (when (and (= id callback-id) (not @completed?))
             (reset! completed? true)
             (try
               (let [result (uc/json-parse result-str)]
                 (on-complete {:success true :marker-details result}))
               (catch js/Error e
                 (log {:error "Failed to parse listMarkerDetailsAsync response"
                       :message (.-message e)
                       :result-str result-str})
                 (on-complete {:success false
                               :message (str "Parse error: " (.-message e))
                               :marker-details nil}))))))
       ;; Set a timeout in case callback never fires (15 seconds)
       (js/setTimeout
         (fn []
           (when (not @completed?)
             (reset! completed? true)
             (on-complete {:success false
                           :message "Marker details fetch timed out"
                           :marker-details nil
                           :timeout true})))
         15000)
       ;; Fire the async call
       (.listMarkerDetailsAsync js/PrintingInterface printer-uri callback-id))
     :clj nil))

(defn list-printer-jobs-async-available?
  "Check if the async printer jobs method is available on this device."
  []
  #?(:cljs
     (and
       (uc/capability-exists? :direct-print)
       (exists? js/PrintingInterface)
       (exists? (.-listPrinterJobsAsync js/PrintingInterface)))
     :clj false))

(defn list-printer-jobs-async
  "Async version of list-printer-jobs that doesn't block the UI thread.
   Registers a callback, calls the async method, and handles the response."
  [printer-uri on-complete]
  #?(:cljs
     (let [callback-id (str (random-uuid))
           completed? (atom false)]
       ;; Register the callback handler on window
       (aset js/window "printerJobsCallback"
         (fn [id result-str]
           (when (and (= id callback-id) (not @completed?))
             (reset! completed? true)
             (try
               (let [result (uc/json-parse result-str)]
                 (on-complete {:success true :jobs result}))
               (catch js/Error e
                 (log {:error "Failed to parse listPrinterJobsAsync response"
                       :message (.-message e)
                       :result-str result-str})
                 (on-complete {:success false
                               :message (str "Parse error: " (.-message e))
                               :jobs nil}))))))
       ;; Set a timeout in case callback never fires (15 seconds)
       (js/setTimeout
         (fn []
           (when (not @completed?)
             (reset! completed? true)
             (on-complete {:success false
                           :message "Printer jobs fetch timed out"
                           :jobs nil
                           :timeout true})))
         15000)
       ;; Fire the async call
       (.listPrinterJobsAsync js/PrintingInterface printer-uri callback-id))
     :clj nil))

(defn printer-job-details [printer-uri job-id]
  #?(:cljs
     (when (uc/capability-exists? :direct-print)
       (let [job-details (.jobDetails js/PrintingInterface printer-uri job-id)]
         job-details))))

(defn list-printer-markers [printer-uri]
  #?(:cljs
     (when (uc/capability-exists? :direct-print)
       (let [printer-marker-details (.listMarkerDetails js/PrintingInterface printer-uri)]
         (cond
           (str/starts-with? printer-marker-details "[")
           {:success true :marker-details printer-marker-details}

           :else
           {:success false :msg printer-marker-details})))))

;;===============================================================
;;                      ALERT MODAL
;;===============================================================
(rum/defc direct-print-modal-body < rum/reactive cmn/cursors [app-atom modal-atom m-config]
  (let [{:keys [severity]} (rum/react modal-atom)]
    [:div
     (headings/heading "Device Alert" {:type :h4 :size :medium})
     [:hr]
     [:div
      (cond
        (= severity :error)
        [:p "This device is no longer able to print."]

        (= severity :warning)
        [:p "This device is only able to print labels."]

        (= severity :unknown)
        [:p "An error occurred while trying to print, please try again. If this issue persists, it may be due a required update."])
      [:p "We're in the process of upgrading our devices."]]]))

(rum/defc direct-print-modal-footer [app-atom _ _]
  (grid/button-row
    {:single-text "Close"
     :single-style :primary
     :single-no-icon true
     :single-fn
     #(grid/dispatch-modal-action app-atom :print-direct/close-feedback {})}))

(defmethod grid/modal-config :direct-print/upgrade-alert [_ _ _]
  {:body direct-print-modal-body
   :footer direct-print-modal-footer
   :modal-type :alert
   :close-action? true
   :cancel-key :print-direct/close-feedback})

(defmethod grid/action :print-direct/close-feedback [app-atom config]
  (let [alert-info (cmn/curact (grid/modal-cursor app-atom) :config)]
    (log alert-info)))

;;===================-------------------=====================
;;           DEVICE PRINTER ERROR MODAL
;;===================-------------------=====================

(rum/defc device-print-error-modal < rum/reactive cmn/cursors
  [app-atom modal-atom m-config]
  (let [{:keys [error-message]} (rum/react modal-atom)]
    [:div
     (headings/heading "Device Printer Error" {:type :h4 :size :medium})
     [:hr]
     [:p "The device printer encountered an error:"]
     [:pre {:style {:color "red" :font-size "12px" :overflow "auto" :max-height "100px"}}
      error-message]
     [:p "Please choose an option:"]]))

(rum/defc device-print-error-footer [app-atom modal-atom _]
  (let [config (cmn/curact modal-atom :original-config)]
    (grid/button-row
      {:left-text "Retry"
       :left-style :secondary
       :left-fn
       #(do
          (grid/close-modal app-atom)
          (device-print-structured app-atom config))

       :center-text "Scan Bixolon"
       :center-style :primary
       :center-fn
       #(do
          (grid/close-modal app-atom)
          (t/transition-next app-atom :payment/finish))

       :right-text "Cancel"
       :right-style :text
       :right-fn
       #(grid/close-modal app-atom)})))

(defmethod grid/modal-config :device-print/error-modal [_ _ _]
  {:body device-print-error-modal
   :footer device-print-error-footer
   :modal-type :alert
   :close-action? true})
